const data = [
  // Step
  {
    id: 1,
    title: "Portfolio Accounting",
    note_title: "Did you know?",
    note: "Within community management, one of the biggest challenges is preparing reconciled financial statements in a timely manner.<br><br>At Pacific Premier Bank, we offer integrations that automatically match most transactions directly in your software, accessible 24/7 in real time.  Save time spent on the reconciliation process without waiting until month's end.<br><br><i>With Auto Reconciliation using Pacific Premier API Banking, account reconciliation is reduced to approximately five minutes per account.</i>",
    question_list: [
      // question
      {
        type: "input",
        question: "How many communities do you manage?",
        name: "communities",
        currency: null,
        unit: 'Communities',
        popup: null,
        max_value: null,
        min_value: null,
        range_step: null,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null,
      },
      // question
      {
        type: "input",
        question: "What is the hourly rate for an accounting team member?",
        name: "accountingRate",
        currency: null,
        unit: "$/Hour",
        popup: null,
        max_value: null,
        min_value: null,
        range_step: null,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
      // question
      {
        type: "input",
        question: "How many bank accounts do you reconcile each month?",
        name: "bankAccount",
        currency: null,
        unit: "/Month",
        popup: null,
        max_value: null,
        min_value: null,
        range_step: null,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
      // question
      {
        type: "input",
        question: "Approximately how long does it take to reconcile each account, including posting ending balance and interest earned?",
        name: "reconcileTime",
        currency: null,
        unit: "Minutes",
        popup: null,
        max_value: 100,
        min_value: 0,
        range_step: 10,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
    ],
  },
  // Step
  {
    id: 2,
    title: "Bank Statements",
    note_title: "Did you know?",
    note: "Most banks provide electronic statements within online banking or through email files, requiring you to jump between your financial software and the bank’s platform to process each statement.<br><br>At Pacific Premier Bank, we offer integrations that send your statements directly into your software, eliminating the need to retrieve, sort, and load statement files. Plus, you can program your software to include them within each community’s monthly financial package . . . and it's all automated! ",
    question_list: [
      // question
      {
        type: "range",
        question: "How much total time do you spend processing bank statements each month?",
        name: "statementTime",
        currency: null,
        unit: "Minutes",
        popup: "Time spent on statement tasks like opening mail, downloading or separating statement files, printing, and scanning into community financial packages.",
        max_value: 120,
        min_value: 0,
        range_step: 15,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
    ],
  },
  // Step
  {
    id: 3,
    title: "Transfers",
    note_title: "Did you know?",
    note: "Most banks only provide “Book Transfer” capabilities through online banking, requiring you to duplicate efforts, entering information in both your financial system and the bank’s platform.<br><br>At Pacific Premier Bank, we offer integrations that allow you to perform these transfers within your system in real time, accelerating the process and reducing errors related to jumping between systems.<br><br><i>With internal transfers between accounts using Pacific Premier API Banking, a transfer can typically be processed in approximately one minute without leaving your accounting system.</i>",
    question_list: [
      // question
      {
        type: "input",
        question: "How many transfers does each community make between bank accounts each month?",
        name: "transfers",
        currency: null,
        unit: null,
        popup: "Transfers might include moving funds between operating and reserve accounts via physical check or online method.",
        max_value: null,
        min_value: null,
        range_step: null,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
      // question
      {
        type: "range",
        question: "How long does it take to process an electronic transfer on your bank's website or produce a check to process a transfer between accounts?",
        name: "transfersTime",
        currency: null,
        unit: "Minutes",
        popup: null,
        max_value: 30,
        min_value: 0,
        range_step: 5,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
    ],
  },
  // Step
  {
    id: 4,
    title: "Lockbox Processing",
    note_title: "Did you know?",
    note: "Pacific Premier API Banking fully automates validation and lockbox file processes to eliminate manual processes, improving timeliness and accuracy.<br><br>Companies who don’t currently use a lockbox can eliminate time spent receiving and posting payments to owner ledgers.",
    question_list: [
      // question
      {
        type: "range",
        question: "How much time is spent uploading validation files and downloading the lockbox posting file <span class='nobreak'>each day?</span>",
        name: "lockboxUpload",
        currency: null,
        unit: "Minutes",
        popup: null,
        max_value: 30,
        min_value: 0,
        range_step: 10,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
    ],
  },
  // Step
  {
    id: 5,
    title: "Positive Pay  - Fraud Detection",
    note_title: "Did you know?",
    note: "Positive Pay is a fraud detection tool that matches the payee, check number, and dollar amount of each check presented for payment against a list of checks previously authorized and issued on your account.<br><br>With Pacific Premier API Banking, your accounts payable data is automatically uploaded to the bank as frequently as every 15 minutes. Never manually upload a file again.",
    question_list: [
      // question
      {
        type: "range",
        question: "How long does it take to upload Positive Pay files to your bank each day?",
        name: "positivePay",
        currency: null,
        unit: "Minutes",
        popup: null,
        max_value: 60,
        min_value: 0,
        range_step: 5,
        show: true,
        checkbox: null,
        checkbox_label: "Do you upload a Positive Pay file to the bank for fraud detection?",
        radioButton: true,
        radioButtonQuestion: "Do you upload a Positive Pay file to the bank for fraud detection?",
        radioButtonOptions: ["Yes", "No"]
      },
    ],
  },
  // Step
  {
    id: 6,
    title: "Research",
    note_title: "Did you know?",
    note: "Banks typically provide research options within online banking platforms, requiring you to jump between your financial system and the bank’s platform when researching.<br><br>At Pacific Premier Bank, you can access data within your system in real time, so you can view check images and much more with Pacific Premier API Banking.",
    question_list: [
      // question
      {
        type: "range",
        question: "How many check images do you research each month <strong>per association</strong> (on average)?",
        name: "research",
        currency: null,
        unit: null,
        popup: null,
        max_value: 30,
        min_value: 5,
        range_step: 5,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
      // question
      {
        type: "range",
        question: "How long do you spend searching for a check image at your bank or lockbox website?",
        name: "searching",
        currency: null,
        unit: "Minutes",
        popup: null,
        max_value: 20,
        min_value: 5,
        range_step: 5,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
    ],
  },
  // Step
  {
    id: 7,
    title: "New Account Opening",
    note_title: "Did you know?",
    note: "Opening new bank accounts can be done directly through Pacific Premier API Banking without the need to fill out forms and send secure emails.<br><br>Use the data already included in your system to pass information along securely and open new accounts.<br><br>Accounts will be opened and account numbers will be posted automatically back into your system, saving time and reducing errors.<br><br><i>With automated account opening using Pacific Premier API Banking, submitting an account opening request can be done in approximately three minutes without leaving your accounting system.</i>",
    question_list: [
      // question
      {
        type: "input",
        question: "How many new bank accounts do you open each month?",
        name: "newAccountOpen",
        currency: null,
        unit: 'Accounts',
        popup: null,
        max_value: null,
        min_value: null,
        range_step: null,
        show: true,
        checkbox: false,
        checkbox_label: null,
      },
      // question
      {
        type: "range",
        question: "How long does it take to fill out forms and provide information to your bank and process each new account opening request?",
        name: "newAccountForms",
        currency: null,
        unit: "Minutes",
        popup: "Time spent completing forms to request an account, as well as time spent receiving and entering the new bank account numbers into your system.",
        max_value: 20,
        min_value: 5,
        range_step: 5,
        show: true,
        checkbox: false,
        checkbox_label: null,
      },
    ],
  },
  // Step
  {
    id: 8,
    title: "Stop Payments",
    note_title: "Did you know?",
    note: "Initiating Stop Payments typically requires going to your bank’s online platform, completing a form, and then returning to your accounting system to locate the check and post the Stop Payment in your system. With Pacific Premier API Banking, Stop Payments are posted and immediately placed by  Pacific Premier with one click inside your software.",
    question_list: [
      // question
      {
        type: "input",
        question: "How many stop payments do you place each month <strong>across all</strong> accounts (on average)?",
        name: "stopPayment",
        currency: null,
        unit: 'Stops',
        popup: null,
        max_value: null,
        min_value: null,
        range_step: null,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
      // question
      {
        type: "range",
        question: "How much time do you spend going to your bank’s website or emailing forms to your bank to place a single stop payment?",
        name: "stopPaymentTime",
        currency: null,
        unit: "Minutes",
        popup: null,
        max_value: 15,
        min_value: 0,
        range_step: 5,
        show: true,
        checkbox: false,
        checkbox_label: null,
        radioButton: false,
        radioLables: null
      },
    ],
  },

];

function StepsData() {
  return data;
}

export default StepsData;
